import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b06e74f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homepage-root-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lead-header" }, "How do we...", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Persevere", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-header" }, "in School, at home, and in life.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning" }, "You must submit a name to continue.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-rules" }, [
  /*#__PURE__*/_createTextVNode(" By entering your name you do not submit any additional information other than your answers. We may log our servers."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "This site was developed and is maintained and owned by Alexander Bobo."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", null, "Contact me: buisness@alexdr.tech for inquiries."),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-2" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _withDirectives(_createElementVNode("input", {
      class: "input is-large",
      type: "text",
      placeholder: "Name",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.name.value) = $event))
    }, null, 512), [
      [_vModelText, $setup.name.value]
    ]),
    _hoisted_7,
    _createElementVNode("button", {
      class: "button is-large is-dark mt-5 button-font",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
    }, "Lets go!"),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    ($setup.config.developmentMode == true && $setup.config.loginPermsWithoutDevMode == true)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button is-warning mt-5",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPolling && _ctx.goToPolling(...args)))
        }, "[Dev] Continue to Polling without login"))
      : ($setup.config.developmentMode == true && $setup.config.loginPermsWithoutDevMode == false)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button is-warning mt-5",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToPolling && _ctx.goToPolling(...args))),
            disabled: ""
          }, "[Dev] Continue to Polling without login"))
        : _createCommentVNode("", true),
    _hoisted_12
  ]))
}